import { type SomeJSONSchema } from 'ajv/dist/types/json-schema';
import { PropertyTypes } from './property-types';
import { setValidationProperties } from '../../utils/validation';
import { type ValidationBooleanType } from '@wix/ambassador-forms-v4-form/types';
import { ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import { BOOLEAN_VALIDATION_PROPERTIES } from '../schema-validation-properties';

export function mapToBooleanSchemaProperty(
  boolField: ValidationBooleanType,
  validationMode: ValidationMode,
): SomeJSONSchema {
  return {
    type: PropertyTypes.BOOLEAN,
    ...resolveRestrictedValidationProperties(boolField, validationMode),
  };
}

function resolveRestrictedValidationProperties(
  boolField: ValidationBooleanType,
  validationMode: ValidationMode,
) {
  if (validationMode !== ValidationMode.UNRESTRICTED_UPDATE) {
    return {
      ...setValidationProperties<boolean>(
        BOOLEAN_VALIDATION_PROPERTIES,
        boolField,
      ),
    };
  }
  return {};
}
